import React from 'react';
import * as Characters from "./CharacterAssets";

function getImage(id, pixelRatio = ``) {
  if (pixelRatio) pixelRatio = `${pixelRatio}x`
  return Characters.default[id][`img${pixelRatio}`];
}

function Character({ alt, id, className }) {
  if (!alt) alt = id
  return <img alt={alt} className={className}
    src={getImage(id)}
    srcSet={`${getImage(id, 2)} 2x, ${getImage(id, 3)} 3x`}
  />
}

export default Character;